import { useSuspenseQuery } from '@tanstack/react-query';
import { naverApi } from '@/shared/api';
import { useDebounceText } from '@/shared/lib';
import { searchKeys } from '../api/search.keys';

const useSearchNaver = (searchText: string) => {
	const debouncedText = useDebounceText(searchText, 300);

	const { data } = useSuspenseQuery({
		queryFn: () => naverApi.searchPlace(debouncedText),
		queryKey: searchKeys.naver(debouncedText),
	});

	return data?.items ?? [];
};

export default useSearchNaver;
